<template>
  <div>
    <v-overlay
      class="text-center"
      :z-index="6"
      :value="searchField"
      @click="searchField = false"
    >
      <v-btn
        color="white"
        class="white--text"
        fab
        outlined
        small
        @click="searchField = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-text-field
        append-icon="mdi-magnify"
        text
        style="margin-right:15px; width:400px"
      />
    </v-overlay>

    <v-app-bar
      app
      :flat="!isUserScrolling"
      height="75"
      extended
      extension-height="60"
      style="background:#fff;z-index:994"
    >
      <v-app-bar-nav-icon
        class="hidden-lg-and-up"
        @click="toggleDrawer"
      />
      <v-container
        class="mt-2 mx-auto py-0"
        style="z-index:8"
      >
        <v-row
          class="align-items-center"
        >
          <v-spacer class="hidden-lg-and-up" />

          <v-col>
          <!-- <div class="col-3"> -->
            <v-img
              src= "@/assets/logo.png"
              contain
              max-height="70px"
              max-width="12rem"
              @click="goHome()"
            />

            <v-row align="center" justify="center">
              <h6 id="slogan">{{$root.$t('slogan')}}</h6>
              <v-spacer id="slogan_spacer"/>
            </v-row>
          
          <!-- <h6 id="slogan">{{$root.$t('slogan')}}</h6> -->
          <!-- </div> -->

          </v-col>
          

          <v-spacer />

          <el-select
            v-model="selected"
            remote
            filterable
            reserve-keyword
            :placeholder="$t('Search for a product...')"
            style="width:25%"
            class="hidden-md-and-down"
            :remote-method="getItems"
            :loading="isSearching"
          >
            <i
              slot="prefix"
              class="el-icon-search el-input__icon"
            />
            <el-option
              v-for="item in items"
              :key="item.product_id"
              class="py-3 h-100"
              :value="item.product_name"
            >
              <div class="row">
                <div class="col-3">
                  <el-image
                    style="width: 50px; height: 50px"
                    :src="baseURL + item.image"
                    fit="fill"
                  />
                </div>
                <div class="col-9">
                  <h6 class="m-0 p-0">
                    {{ item.product_name }}
                  </h6>
                  {{ item.brand_name }}
                </div>
              </div>
            </el-option>
          </el-select>

          <v-badge
            color="primary"
            :class="marginDir"
            :content="itemsCount"
            :value="itemsCount"
            bottom
            overlap
          >
            <v-btn
              :disabled="!itemsCount"
              color="secondary"
              class="white--text"
              fab
              outlined
              small
              @click="$router.push('/check-out')"
            >
              <v-icon>mdi-cart</v-icon>
            </v-btn>
          </v-badge>

          <!-- <vue-country-code
                  class="hidden-md-and-down"
                  @onSelect="onCountrySelect"
                  :disabledFetchingCountry=true
                  :defaultCountry='getDefault()'
                  :dropdownOptions={disabledDialCode:true}
                  :onlyCountries="['sd', 'tz']">
            </vue-country-code> -->
        </v-row>
        
        
      </v-container>
      <template v-slot:extension>
        <v-container class="mx-auto py-2 px-0">
          <v-row>
            <!-- <vue-country-code
                  class="hidden-lg-and-up"
                  @onSelect="onCountrySelect"
                  :disabledFetchingCountry=true
                  :defaultCountry='getDefault()'
      
                  :dropdownOptions={disabledDialCode:true}
                  :onlyCountries="['sd', 'tz']">
            </vue-country-code> -->

            <el-select
              v-model="selected"
              remote
              filterable
              reserve-keyword
              placeholder="Search for a product..."
              style=" width: 100%;"
              class="hidden-lg-and-up"
              :remote-method="getItems"
              :loading="isSearching"
            >
              <i
                slot="prefix"
                class="el-icon-search el-input__icon"
              />
              <el-option
                v-for="item in items"
                :key="item.product_id"
                class="py-3 h-100"
                :value="item.product_name"
              >
                <div class="row">
                  <div class="col-3">
                    <el-image
                      style="width: 50px; height: 50px"
                      :src="baseURL + item.image"
                      fit="fill"
                    />
                  </div>
                  <div class="col-9">
                    <h6 class="m-0 p-0">
                      {{ item.product_name }}
                    </h6>
                    {{ item.brand_name }}
                  </div>
                </div>
              </el-option>
            </el-select>

            

            <v-btn
              to="/"
              color="secondary"
              class="ml-0 hidden-md-and-down nav-btn"
              text
            >
              {{ $root.$t('HOME') }}
            </v-btn>
            <v-btn
              v-for="(item, index) in categories"
              :key="index"
              :to="item.to"
              style="padding:0 10px !important;"
              color="secondary"
              class="ml-0 hidden-md-and-down nav-btn"
              text
              @click="toProducts(item, 'false', 'false')"
            >
              {{ $root.$t(item.text.toUpperCase()) }}
            </v-btn>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="secondary"
                  class="ml-0 hidden-md-and-down nav-btn"
                  text
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ $t('new arrivals') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in categories"
                  :key="index"
                >
                  <v-list-item-title
                    style="color:#2e368f;cursor:pointer"
                    @click="toProducts(item , 'false' , 'true')"
                  >
                    {{ $root.$t(item.text.toUpperCase()) }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="secondary"
                  class="ml-0 hidden-md-and-down nav-btn"

                  text
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ $t('special prices') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in categories"
                  :key="index"
                >
                  <v-list-item-title
                    style="color:#9d6d59;cursor:pointer"
                    @click="toProducts(item , 'true' , 'false')"
                  >
                    {{ $root.$t(item.text.toUpperCase()) }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-spacer class="hidden-md-and-down" />
            <v-btn
              to="/about"

              color="secondary"
              class="ml-0 hidden-md-and-down nav-btn"
              text
            >
              {{ $root.$t('ABOUT US') }}
            </v-btn>
            <v-btn
              to="/contact"

              color="secondary"
              class="ml-0 hidden-md-and-down nav-btn"
              text
            >
              {{ $root.$t('CONTACT US') }}
            </v-btn>
            <v-btn
              color="secondary"
              class="text-center hidden-md-and-down"
              icon
              style="width:35px;height:35px; padding-left: 25px; padding-right: 35px;"
              @click="changeLang(langChoose)"
            >
              {{ langName }}
            </v-btn>
          </v-row>
        </v-container>
      </template>
    </v-app-bar>
  </div>
</template>

<style>
  .v-btn:not(.v-btn--round).v-size--default{
    height: 36px;
    min-width: 64px;
    padding: 0 8px;
  }
</style>

<script>
// Utilities
  import { i18n } from '@/main'

  import { mapGetters, mapMutations } from 'vuex'
  export default {
    computed: {
      ...mapGetters(['categories', 'links']),
      langChoose () {
        return localStorage.getItem('lang') == 'ar' ? 'en' : 'ar';
      },
      langName () {
        if(!localStorage.getItem('lang')){
          localStorage.setItem('lang', 'en');
        }
        return localStorage.getItem('lang') == 'ar' ? 'English' : localStorage.getItem('country') == 'TZ' ? '' : 'عربي';
      },
      marginDir () {
        return localStorage.getItem('lang') == 'ar' ? 'mr-2' : 'ml-2'
      },
      baseURL: {
        get() {return localStorage.getItem('country') == 'TZ' ? 'https://tz.time-zone.store' : 'https://time-zone.store/'}
      }
    },
    data: () => ({
      loaded: 0,
      selected: null,
      isUserScrolling: false,
      itemsCount: 0,
      searchField: false,
      isSearching: false,
      search: null,
      items: [],
      countries: [
        {
        name: "Sudan",
        flag: "em-flag-su"
        },
          {
          name: "Tanzania",
          flag: "em-flag-ad",
         },
      ]
    }),
    watch: {
      search (val) {
        val && val !== this.select && this.getItems(val)
      },
      selected (val) {
        if (val) {
          const product = this.items.find(e => e.product_name == val)
          this.goToProduct(product, 'false', 'false')
        }
      },
    },
    methods: {
      goHome(){
        this.$router.push({path: `/`});
      },
      
      onCountrySelect({name, iso2, dialCode}) {
       console.log(name, iso2, dialCode);
       if(this.loaded >= 2 && (iso2 == 'TZ' || iso2 == 'SD')){
         localStorage.clear();
         localStorage.setItem('country', iso2);

          this.goHome();
          window.location.reload();
       }
       this.loaded += 1;
     },

     getDefault(){
       var forceReload = false;
  
       var country = this.$route.params.country == 'Sudan' ? 'SD' : this.$route.params.country == 'Tanzania' ? 'TZ' : '';
       if(country == ''){
         country = this.$route.path == '/Sudan' ? 'SD' : this.$route.path == '/Tanzania' ? 'TZ' : '';
         if(country != ''){
           forceReload = true;
         }
       }

       var savedCountry = localStorage.getItem('country');
       if(country != '' && country != savedCountry){
         localStorage.setItem('country', country);

         if(forceReload){
           this.goHome();
           forceReload = false;
         }
         window.location.reload();
       }else if(forceReload){
           this.goHome();
           forceReload = false;
       }
       

       country = savedCountry;
       return country;
     },
      goToProduct (product) {
        localStorage.setItem('categoryId', product.category_id)
        localStorage.setItem('productId', product.product_id)

        this.selected = null
        this.$router.push(
          `/products/${
            this.categories.find(e => e.id === product.category_id).text
          }/${product.product_name}`
        )
      },
      getItems (val) {
        if (this.isSearching) return

        this.isSearching = true
        axios
          .get(`/v1/international/product?search=${val}`)
          .then(res => {
            this.items = res.data.data
            this.isSearching = false
          })
          .catch(err => {
            this.isSearching = false
          })
      },
      ...mapMutations(['toggleDrawer']),
      onClick (e, item) {
        e.stopPropagation()
        if (item.to || !item.href) return
        this.$vuetify.goTo(item.href)
      },
      handleScroll (event) {
        this.isUserScrolling = window.scrollY > 0
      },
      toProducts (item, special, arrival) {
        localStorage.setItem('categoryId', item.id)
        localStorage.setItem('special_filter', special)
        localStorage.setItem('arrival_filter', arrival)
        localStorage.removeItem('brandFilter');
        localStorage.removeItem('filterId');
        localStorage.removeItem('filterValue'); 
        window.dispatchEvent(
          new CustomEvent('special-arrival-flag-changed', {})
        )
        
        var counrty = localStorage.getItem('country') === 'TZ' ? 'Tanzania' : 'Sudan'
        this.$router.push({ path: `/products/${item.text}` }) ///${counrty}
      },
      changeLang (lang) {
        // lang = localStorage.getItem('country') == 'SD' ? lang : lang == 'ar' ? 'sw': lang;        
        this.$vuetify.rtl = lang === 'ar'
        localStorage.setItem('lang', lang)
        i18n.locale = lang
        const accHead = lang === 'en' ? 'en-us-1' : 'ar-sy-1'
        console.log(accHead)
        window.axios.defaults.headers.common['Accept-Language'] = accHead
        window.location.reload()
      },
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
      this.itemsCount = localStorage.getItem('itemsCount')
      window.addEventListener('itemsCount-localstorage-changed', event => {
        this.itemsCount = event.detail.storage
      })
    },
  }
</script>

<style lang="scss"  >
.vue-country-select{
  border: none !important;
  margin: 0 10px;
}
.nav-btn{
  font-family:'Tajawal', sans-serif !important;
  font-size:12.5px !important;
}
a:hover {
  text-decoration: none !important;
}
.prime {
  color: #2e368f;
  letter-spacing: 0.0973529412em !important;
  font-size: 2.125rem !important;
  font-weight: 300;
  line-height: 2.5rem;
  font-family: "Roboto", sans-serif !important;
  @media screen and (max-width: 500px) {
    font-size: 1.8rem !important;
  }
}
.v-toolbar__extension {
  background-color: #ecebecb0 !important;
  z-index: -1 !important;
}
.v-menu__content {
  z-index: 995 !important;
}
.el-input__inner {
  border: none !important;
  border-bottom: 1px solid #2e368f !important;
  background: transparent !important;
}

#slogan{
  color: #2e368f; 
  padding-left: 3.1rem; 
  padding-right: 3.1rem; 
  @media screen and (max-width: 1080px) {
    padding-left: 1.1rem; 
    padding-right: 1.1rem; 
  }
}
#slogan_spacer{
  @media screen and (max-width: 1080px) {
    display: none;
  }
}
</style>
